/** The one place that reads `import.meta.env` — everything else imports from here. */

export const GOOGLE_OAUTH_CLIENT_ID: string = import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID ?? ''

/**
 * The app's public origin (e.g. `https://pivot.example.com`), no trailing
 * slash. PIVOT-137: `index.html`'s `og:image`/`og:url` need an absolute URL —
 * a social-card scraper fetches the raw HTML and never runs JS, so
 * `window.location.origin` (only known after the bundle loads) can't supply
 * it. Same build-arg pattern as `VITE_GOOGLE_OAUTH_CLIENT_ID` (see
 * `infra/main.tf`); empty in dev, where a relative `og:image` is good enough
 * since nothing pastes a `localhost` link into a card debugger.
 */
export const APP_ORIGIN: string = import.meta.env.VITE_APP_ORIGIN ?? ''
